/**
 * Application Configuration Constants
 */

// Google OAuth Configuration
// Replace with your actual Google Client ID from Google Cloud Console
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || 'YOUR_GOOGLE_CLIENT_ID';

// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1';

// App Configuration
export const APP_NAME = 'AI Object Detection';
export const APP_VERSION = '1.0.0';
